import React, { useState } from 'react';
import { InputAdornment, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import InputTextField, { InputTextFieldProps } from './TextField';

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    '&::-webkit-outer-spin-button,::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '-moz-appearance': 'textfield',
  },
}));

export function PercentageInputTextField(props: InputTextFieldProps) {
  const classes = useStyles();
  const [shouldShowAdornment, setShouldShowAdornment] = useState(false);
  const adornment = <InputAdornment position="end">%</InputAdornment>;

  const {
    InputProps: injectedInputProps = {},
    TextFieldProps: injectedTextFieldProps = {},
  } = props;

  const {
    classes: inputClasses = {},
    inputProps = {},
    ...restInputProps
  } = injectedInputProps;
  const { root: rootInputClass = '', ...restInputClasses } = inputClasses;
  const InputProps = {
    placeholder: '00',
    classes: {
      root: `${classes.input} ${rootInputClass}`,
      ...restInputClasses,
    },
    inputProps: {
      min: 0,
      max: 100,
      ...inputProps,
    },
    ...restInputProps,
    endAdornment: shouldShowAdornment ? adornment : undefined,
  };

  const { onFocus, onBlur, ...restTextFieldProps } = injectedTextFieldProps;
  const TextFieldProps = {
    ...restTextFieldProps,
    onFocus: (e) => {
      setShouldShowAdornment(true);
      onFocus && onFocus(e);
    },
    onBlur: (e) => {
      if (!e.target.value) setShouldShowAdornment(false);
      onBlur && onBlur(e);
    },
  };
  return (
    <InputTextField
      type="number"
      {...props}
      TextFieldProps={TextFieldProps}
      InputProps={InputProps}
    />
  );
}
